import React, {Component, Fragment} from 'react';
import _ from 'lodash';
import Modal from '../uicore/Modal';
import {hourGlass} from 'assets';

//Below timeout values are coming from .env file in ClientApp root folder
// const LOGOUT_TIMEOUT = 10 * 60;
// const WARNING_TIMEOUT = 9 * 60;
const TIMER = 59;

// const LOGOUT_TIMEOUT = 1000;
// const WARNING_TIMEOUT = 30;
// const TIMER = 9;

export const withAutoLogout = (WrappedComponent) => {
  return class ContainerComponent extends Component {
    constructor() {
      super();
      //This is to throttle the execution of resetting timer atlmost once in a second to avoid unnecessary js execution
      this.resetTimeouts = _.throttle(this.resetTimer, 1000);
      this.state = {
        isWarning: false,
        timer: TIMER, //(signoutTime-warningTime)      //30*60 Seconds
      };
    }
    componentDidMount() {
      this.events = [
        'load',
        'mousemove',
        //'mousedown',
        'click',
        // 'scroll',
        'keypress',
      ];

      for (var i in this.events) {
        window.addEventListener(this.events[i], this.resetTimeouts);
      }
      this.setTimeouts();
      this.setState({timer: TIMER});
    }
    componentWillUnmount() {
      for (var i in this.events) {
        window.removeEventListener(this.events[i], this.resetTimeouts);
      }
      this.clearTimeoutFunc();
    }

    clearTimeoutFunc = () => {
      if (this.warnTimeout) clearTimeout(this.warnTimeout);
      if (this.logoutTimeout) clearTimeout(this.logoutTimeout);
      if (this.countDown) clearInterval(this.countDown);
    };

    setTimeouts = () => {
      const logoutMillis = Number(process.env.REACT_APP_TIMEOUT) * 60 * 1000;
      const warningMillis = (Number(process.env.REACT_APP_TIMEOUT) - 1) * 60 * 1000;
      //const logoutMillis = 120 * 1000;
      //const warningMillis = 60 * 1000;
      this.warnTimeout = setTimeout(this.warn, warningMillis);
      this.logoutTimeout = setTimeout(this.logout, logoutMillis);
    };

    resetTimer = () => {
      this.clearTimeoutFunc();
      this.setTimeouts();
      this.setState({isWarning: false, timer: TIMER});
    };
    setTimerFunc = () => {
      this.countDown = setInterval(() => {
        const newCount = this.state.timer - 1;
        this.setState({timer: newCount >= 0 ? newCount : 0});
      }, 1000);
    };
    warn = () => {
      this.setState({isWarning: true});
      this.setTimerFunc(); // Start countdown Timer
    };

    logout = async () => {
      this.clearTimeoutFunc();
      this.setState({isWarning: false});
      const account = this.props.pca.getActiveAccount();
      console.log(account);
      // await this.props.pca.logoutPopup({account});
      this.props.sessionTimeout();
      this.destroy();
    };

    destroy = () => {
      //clear the session
      // browserHistory.push('/');
      // window.location.assign('/');
    };

    render() {
      return (
        <Fragment>
          {this.state.isWarning && (
            <Modal propStyle="modalDark">
              <div
                id="timeoutWarning"
                className="modalcontainerXSm paddingLg borderRadiusAllLg flexContainer noCols alignCenter">
                <img className="timeoutgraphic" src={hourGlass} alt="" />
                <div>
                  <div className="fontHdr2">{this.props.t('SessionTimeout-label')}</div>
                  <p>{`${this.props.t('msg-logout')} ${this.state.timer}`}</p>
                </div>
              </div>
            </Modal>
          )}
          <WrappedComponent {...this.props} />
        </Fragment>
      );
    }
  };
};

export default withAutoLogout;
